document.addEventListener("DOMContentLoaded", function () {
    let productList = document.getElementById("product-list");
    let nextPageLink = document.getElementById("next-page");
    let container = document.querySelector(".load-more-container");

    if (!productList || !container) {
        return;
    }

    let paginationType = container.dataset.paginationType || "click";
    let isLoading = false;

    if (!nextPageLink || !nextPageLink.getAttribute("href")) {
        container.style.display = "none";
        return;
    }

    // --- INFINITE SCROLL PATH ---
    if (paginationType === "infinite") {
        let loader = document.getElementById("infinite-scroll-loader");
        if (!loader) return;

        let observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !isLoading && nextPageLink && nextPageLink.getAttribute("href")) {
                    loadNextProductsInfinite();
                }
            });
        }, {
            root: null,
            rootMargin: "250px",
            threshold: 0.1
        });

        observer.observe(loader);

        function loadNextProductsInfinite() {
            let nextPageUrl = nextPageLink.getAttribute("href");
            if (!nextPageUrl) {
                observer.disconnect();
                loader.style.display = "none";
                container.style.display = "none";
                return;
            }

            isLoading = true;
            loader.style.display = "flex";
            container.style.display = "flex";

            let fetchPromise = fetch(nextPageUrl).then(response => response.text());
            let minDelayPromise = new Promise(resolve => setTimeout(resolve, 1000));

            Promise.all([fetchPromise, minDelayPromise])
                .then(([html]) => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, "text/html");

                    let productGrid = doc.getElementById("product-grid");
                    let newItems = productGrid ? productGrid.innerHTML : "";
                    let newNextPage = doc.getElementById("next-page");

                    if (newItems) {
                        productList.insertAdjacentHTML("beforeend", newItems);
                    }

                    if (history && history.replaceState) {
                        history.replaceState(null, "", nextPageUrl);
                    }

                    if (newNextPage && newNextPage.getAttribute("href")) {
                        nextPageLink.setAttribute("href", newNextPage.getAttribute("href"));
                        isLoading = false;
                    } else {
                        nextPageLink.removeAttribute("href");
                        observer.disconnect();
                        loader.style.display = "none";
                        container.style.display = "none";
                        isLoading = false;
                    }
                })
                .catch(error => {
                    console.error("Error loading more products:", error);
                    observer.disconnect();
                    loader.style.display = "none";
                    container.style.display = "none";
                    isLoading = false;
                });
        }
    } 
    // --- CLICK PATH ---
    else if (paginationType === "click") {
        let loadMoreBtn = document.getElementById("load-more");
        if (!loadMoreBtn) return;

        loadMoreBtn.addEventListener("click", function () {
            if (isLoading || !nextPageLink) return;

            let nextPageUrl = nextPageLink.getAttribute("href");
            if (!nextPageUrl) {
                loadMoreBtn.style.display = "none";
                container.style.display = "none";
                return;
            }

            isLoading = true;
            loadMoreBtn.textContent = "Loading...";

            fetch(nextPageUrl).then(response => response.text())
                .then(html => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, "text/html");

                    let productGrid = doc.getElementById("product-grid");
                    let newItems = productGrid ? productGrid.innerHTML : "";
                    let newNextPage = doc.getElementById("next-page");

                    if (newItems) {
                        productList.insertAdjacentHTML("beforeend", newItems);
                    }

                    if (history && history.replaceState) {
                        history.replaceState(null, "", nextPageUrl);
                    }

                    if (newNextPage && newNextPage.getAttribute("href")) {
                        nextPageLink.setAttribute("href", newNextPage.getAttribute("href"));
                        loadMoreBtn.textContent = "Load More";
                        isLoading = false;
                    } else {
                        nextPageLink.removeAttribute("href");
                        loadMoreBtn.style.display = "none";
                        container.style.display = "none";
                        isLoading = false;
                    }
                })
                .catch(error => {
                    console.error("Error loading more products:", error);
                    loadMoreBtn.textContent = "Load More";
                    loadMoreBtn.style.display = "none";
                    container.style.display = "none";
                    isLoading = false;
                });
        });
    }
});
